import { Card, CardHeader } from "@shared/ui/card";

type TProfileHeader = {
	title: string;
	description: string;
};

export default function ProfileHeader({ title, description }: TProfileHeader) {
	return (
		<Card>
			<CardHeader className="gap-1 space-y-0">
				<h2 className="text-xl font-semibold mb-0">{title}</h2>
				<p className="text-sm text-muted-foreground">{description}</p>
			</CardHeader>
		</Card>
	);
}
